<template>
  <button
    class="flex items-center mx-auto gap-4 p-2.5 bg-white text-sm rounded-full px-2.5 font-bold w-full text-start font-sans disabled:opacity-40"
    type="button" v-bind="$attrs">
    <slot name="icon"></slot>
    <div class="flex flex-col">
      <slot></slot>
    </div>
  </button>
</template>

<script setup lang="ts">

defineProps({
  type: {
    type: String,
    default: 'button',
  }, // Define the type prop
});
</script>